import * as z from 'zod';

import { currencyInput } from '@/_schemas/generic';

export const deliverableWholesalePriceQuerySchema = z.object({
  id: z.number(),
  agreement_deliverable_id: z.number(),
  start_date: z.string().nullable(),
  end_date: z.string().nullable(),
  wholesale_price: z.coerce.number<number>().nullable(), //currencyInput.querySchema(),
  wholesale_discount: currencyInput.querySchema(),
});

export const deliverableWholesalePriceFormSchema = deliverableWholesalePriceQuerySchema;
export const deliverableWholesalePriceUpdateSchema = deliverableWholesalePriceQuerySchema;

export type DeliverableWholesalePriceQuerySchema = z.infer<typeof deliverableWholesalePriceQuerySchema>;
export type DeliverableWholesalePriceFormSchema = z.infer<typeof deliverableWholesalePriceFormSchema>;
export type DeliverableWholesalePriceUpdateSchema = z.infer<typeof deliverableWholesalePriceUpdateSchema>;

export type DateRange = Pick<DeliverableWholesalePriceFormSchema, 'start_date' | 'end_date'> | null;

export const modelWholesalePriceItem = {
  id: -1,
  agreement_deliverable_id: -1,
  start_date: null,
  end_date: null,
  wholesale_price: null,
  wholesale_discount: null,
} as DeliverableWholesalePriceFormSchema;
